import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import globalStyles from "../global";
import Footer from "../components/HomeComponent/Footer";
import AccordionUsage from "../components/servicesComponent/Accordin";
import ServiceToggle from "../components/globalCountries/servicesComponent/ServiceToggle";
import News from "../components/globalCountries/countryhomepagescomponent/News";
import PromiseSection from "../components/globalCountries/countryhomepagescomponent/PromoSection";
import CountryBorder from "../components/globalCountries/countryhomepagescomponent/Countryborder";
const containerWidth = "1200px";
const Services = () => {
  const { t } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const part3 = t("countryServices.heroTitle.part3"); // "Cleaning Services"
  const [part3Word1, part3Word2] = part3.split(" "); // ["Cleaning", "Services"]
  return (
    <Box>
      {/* Hero Section */}
      <Box sx={styles.heroSection}>
        <Box sx={styles.container}>
          <Box
            component="img"
            src={`${imageBaseUrl}countryServices.png`}
            alt={t("countryServices.heroTitle.part1")}
            sx={{
              ...styles.heroImage,
              verticalAlign: "bottom",
              display: {
                xs: "none",
                sm: "none",
                md: "block",
              },
            }}
          />
          <Box sx={styles.heroTextBox}>
            <Typography variant="h1" sx={styles.heroTitle}>
              {t("countryServices.heroTitle.part1") +
                " " +
                t("countryServices.heroTitle.part2")}{" "}
              <Box component="span" sx={styles.greenText}>
                {" "}
                {part3Word1} {part3Word2}
              </Box>
            </Typography>
            {/* <Typography variant="h1" sx={styles.heroTitle}>
              {t("countryServices.heroTitle.part2")}
              <Box component="span" sx={styles.greenText}>
                {" "}
                {part3Word1}
              </Box>
            </Typography>
            <Typography variant="h1" sx={styles.heroTitle}>
              <Box component="span" sx={styles.greenText}>
                {part3Word2}
              </Box>
            </Typography> */}
          </Box>
        </Box>
      </Box>
      {/* Services Section */}
      <Box sx={styles.servicesContainer}>
        <Typography variant="h2" sx={styles.sectionTitle}>
          {t("countryServices.subSectionTitle")}
        </Typography>
        <Typography sx={styles.sectionSubtitle}>
          {t("countryServices.sectionSubtitle")}
        </Typography>
      </Box>
      <ServiceToggle />
      <CountryBorder countryCode="uae" />
      <PromiseSection />
      <AccordionUsage />
      <News />
      <Box sx={{ height: "80px" }} />
      <Footer />
    </Box>
  );
};

const styles = {
  heroSection: {
    bgcolor: "#e0e7d8",
    height: {
      xs: "280px",
      sm: "440px",
      md: "500px",
    },
    display: "flex",
    alignItems: "center",
  },
  container: {
    display: "flex",
    flexDirection: {
      xs: "column",
      md: "row",
    },
    gap: "30px",
    // gridTemplateColumns: {
    //   md: 'repeat(2, auto)',
    // },
    justifyContent: "center",
    alignItems: "center",
    maxWidth: containerWidth,
    mx: "auto",
    height: "100%", // <-- Add this
  },

  heroImage: {
    width: {
      xs: 0,         // Hide on mobile
      sm: 0,         // Hide on small screens
      md: "50%",     // Show on md and up
    },
    height: {
      xs: 0,
      sm: 0,
      md: "100%",    // Fill banner height on md and up
    },
    maxHeight: "500px", // Match banner max height
    objectFit: "cover",
    display: {
      xs: "none",
      sm: "none",
      md: "block",
    },
  },
  heroTextBox: {
    minWidth: "400px",
    p: 2,
    py: {
      md: 2,
      xs: 8,
    },
    textAlign: {
      md: "left",
      xs: "center",
    },
  },
  heroTitleContainer: {
    textAlign: "center",
    fontWeight: "bold",
    // px: 2,
    py: 4,
    // ml: { xs: 0, md: "-100px" },
    // mr: 0,
  },
  heroTitle: {
    // fontSize: { lg: getResponsiveSize(55) },
    fontSize: {
      md: "55px",
      sm: "36px",
      xs: "30px",
    },
    color: globalStyles.colors.army_green,
    fontFamily: globalStyles.fonts.primaryUAE,
    letterSpacing: "1%",
  },
  greenText: {
    color: globalStyles.colors.uclean_green,
    display: "inline",
    fontFamily: globalStyles.fonts.primaryUAE,
  },
  heroSubtitle: {
    mt: { xs: 2, md: 4 },
    color: globalStyles.colors.uclean_green,
    fontSize: "inherit",
  },
  servicesContainer: {
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
    pt: 8,
    px: 2,
    textAlign: "center",
  },
  sectionTitle: {
    textAlign: "center",
    fontFamily: globalStyles.fonts.primaryUAE,
    fontWeight: 600,
    px: 4,
    fontSize: "40px",
    color: "#053B26",
    textTransform: "uppercase",
    mb: 1,
  },
  sectionSubtitle: {
    textAlign: "center",
    fontFamily: globalStyles.fonts.primary,
    px: 4,
    fontSize: "18px",
    color: "#666666",
    fontWeight: 400,
  },
};

export default Services;
